<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import ExtraButton from '../../../common/components/ExtraButton.svelte';

  export let label: string;
  export let type;
  export let variant;
  export let width = '100%';
  export let disabled = false;

  const dispatcher = createEventDispatcher();

  function onButtonClick() {
    dispatcher('click', null);
  }
</script>

<ExtraButton {variant} color={type} {disabled} style="min-width : {width} !important" on:click={() => onButtonClick()}>
  {label}
</ExtraButton>

<style lang="scss" global>
  @import '../../../common/styles/colors.new.scss';

  .mdc-button,
  .smui-button--color-secondary {
    border-radius: 100px !important;
    padding: 10px 16px !important;
    font-size: 14px !important;
    line-height: 16px !important;
    min-height: 36px !important;
    border-color: $icon-only-icon-blue !important;
  }

  .mdc-button__label {
    letter-spacing: normal !important;
    font-weight: 700;
  }

  .smui-button--color-secondary {
    color: $color-bg-black;
  }
</style>
